import axios from 'axios'
import { ENVIRONMENT } from './environment.config'

export const SERVER_URL = ENVIRONMENT.SERVER_URL

export const apiClient = axios.create({
  baseURL: SERVER_URL,
  headers: { 'Content-Type': 'application/json; charset=utf-8' },
})
